/** Storage throws in private browsing and when disabled, so every read is guarded. */
export const readAccessToken = (): string => {
    try {
        return localStorage.getItem('accessToken') ?? '';
    } catch {
        return '';
    }
};
